import React, { useState } from 'react'
import SearchNot from '../../images/searchNot.png'
import ReportIcon from '@mui/icons-material/Report';
import FemaleIcon from '@mui/icons-material/Female';
import {  DateRange, Home, Sell, Sensors } from '@mui/icons-material'
import { Container, Row } from 'react-bootstrap'
import { Link } from 'react-router-dom'
import EmptyReturn from '../EmptyReturn';
import useChangeFarm from '../CustomHooks/useChangeFarm';
const moment=require('moment-jalaali')

const SensorList = ({data}) => {
    const {changeFarm}=useChangeFarm()
  return (
    <Container className='allCardsCon'>
     <Row style={{width:'100%'}}>
     {
        data?.length?data.map((item,index)=>{
            const {createAt}=item;
                    const birth=createAt?.substring(0,10);
                    const pbirth=moment(birth).format('jYYYY-jMM-jDD')
            return <div data-aos="zoom-out-down"  key={index} className='  col-sm-12 col-md-6 col-lg-3 col-xl-3   gap-3'>
                <div  className='ThemeCard' >
            <div className='col-lg-6'>
            <div className='ThemeCardItem '>
            <div className='LogoFormT'><div><span>
                <ReportIcon/>
                </span>
                    </div></div>
                <span>وضعیت :</span>
                <span>{item?.cattleStatusId==0?'مطلوب':'نامطلوب'}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Sensors/>
                </span>
                    </div></div> 
                <span>سنسور :</span>
                <span>{item?.deviceCode}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Sell/>
                </span>
                    </div></div> 
                <span>شماره گردنبند :</span>
                <span>{item?.necklaceNumber?item?.necklaceNumber:'---'}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <Home/>
                </span>
                    </div></div> 
                <span> دامداری :</span>
                <span>{item?.farmName}</span>
            </div>
            <div className='ThemeCardItem'>
            <div className='LogoFormT'><div><span>
                <DateRange/>
                </span>
                    </div></div> 
                <span>تاریخ ایجاد :</span>
                <span>{pbirth}</span>
            </div>
            
            
            
            </div>
            
            <Link onClick={()=>{
                        changeFarm(item.farmId)
                      }} to={`/AllSensors/${item.id}`} >
            <div className='btnCardDAm'>

                مشاهده جزئیات
                </div>

            </Link>
          </div>
            </div>
        })
     :<EmptyReturn/>}
     </Row>
    </Container>
  )
}

export default SensorList
